<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="420px">
      <div class="dialog-container">
        <h3>Mark As Endorsed</h3>
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Endorsement</span>
            <el-form-item
              ref="pcy_pdf_path_id"
              prop="pcy_pdf_path_id">
              <v-upload
                :edit="true"
                :card="true"
                :fileData="formData.pcy_pdf"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Policy Number</span>
            <el-form-item
              ref="pcy_no"
              prop="pcy_no">
              <v-input v-model="formData.pcy_no" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Endorsement Number</span>
            <el-form-item
              ref="endorser_no"
              prop="endorser_no">
              <v-input v-model="formData.endorser_no" />
            </el-form-item>
          </div>
          <div
            v-if="!isCancel"
            class="form-item">
            <span>Endorsement Insured Period</span>
            <div class="flex flex-align">
              <el-form-item
                ref="ins_start_dt"
                prop="ins_start_dt">
                <v-date-picker
                  v-model="formData.ins_start_dt"
                  :disabled="!!detail.ins_start_dt"
                />
              </el-form-item>
              <span class="margin-time">To</span>
              <el-form-item
                ref="ins_end_dt"
                prop="ins_end_dt">
                <v-date-picker
                  v-model="formData.ins_end_dt"
                  :disabled="!!detail.ins_end_dt && ![14,15].includes(detail.product_id)"
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-else
            class="form-item">
            <span>Endorsement Insured Period</span>
            <!--            <el-form-item-->
            <!--              ref="ins_end_dt"-->
            <!--              prop="ins_end_dt">-->
            <!--              <v-date-picker-->
            <!--                v-model="formData.ins_end_dt" />-->
            <!--            </el-form-item>-->
            <div class="flex flex-align">
              <el-form-item
                ref="ins_start_dt"
                prop="ins_start_dt">
                <v-date-picker
                  v-model="formData.ins_start_dt"
                  :disabled="!!detail.ins_start_dt"
                />
              </el-form-item>
              <span class="margin-time">To</span>
              <el-form-item
                ref="ins_end_dt"
                prop="ins_end_dt">
                <v-date-picker
                  v-model="formData.ins_end_dt"
                  :disabled="!!detail.ins_end_dt"
                />
              </el-form-item>
            </div>
          </div>
          <template v-if="extraBenefit.length>0">
            <div class="title-span">Driver Personal Accident Insurance </div>
            <div
              v-for="(item,index) in extraBenefit"
              :key="'extra'+index"
              class="item-content">
              <div class="form-item">
                <span>{{item.name}}</span>
                <el-form-item
                  :ref="`${item.key}_path_id`"
                  :prop="`${item.key}_path_id`">
                  <v-upload
                    :card="true"
                    :fileData="item[`${item.key}_path`]"
                    :otherData="{
                      target: 'extra_benefits',
                      idKey: `${item.key}_path_id`,
                      nameKey:`${item.key}_path`,
                      index
                    }"
                    :edit="true"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div
                class="form-item">
                <span>{{item.name}} Policy No.</span>
                <el-form-item
                  :ref="`${item.key}_pcy_no`"
                  :prop="`${item.key}_pcy_no`">
                  <v-input v-model="item[`${item.key}_pcy_no`]" />
                </el-form-item>
              </div>
            </div>
          </template>
        </el-form>
        <div
          class="dialog-footer">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="success"
            @click="onNext">Next</v-button>
        </div>
      </div>
    </v-dialog>

    <send-email-sms
      ref="send-email-sms"
      :form="detail"
      :is-fina="isFina"
      :initContent="detail.endorsed_url_data"
      :initReferContent="detail.referrer_endorsed_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend"
      @skip="handlerSkip" />
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {changeEndorsementStatus} from '@/api/endorsement'

export default {
  name: 'MarkAsEndorsedDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    isCancel: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      dialog: false,
      extraBenefit:[],
      formData: {
        pcy_pdf: null,
        pcy_pdf_path: '',
        pcy_pdf_path_id: '',
        pcy_no: '',
        endorser_no: '',
        ins_start_dt: '',
        ins_end_dt: '',
      },
      extraRules: {
        pcy_pdf_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        ins_start_dt: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        ins_end_dt: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        endorser_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed:{
    emailListTitle(){
      return this.detail.endorsed_url_list_title || ''
    },
    emailTitle(){
      return this.detail.endorsed_url_title || ''
    },
    merchant_platform(){
      let {merchant_platform} = this.detail||{}
      return merchant_platform
    },
    isFina(){
      return this.merchant_platform == 2
    },
  },
  watch:{
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          this.initExtra()
          // const { pcy_no,ins_start_dt,ins_end_dt, extra_benefits_content,extra_content_list} = this.detail||{}
          // const { file } = this.changeUploadData
          // const {path,id} = file||{}
          // // Object.keys(extra_benefits_content).some((item)=>{
          // //   this.formData[item] = {}
          // // })
          // this.formData.pcy_pdf = file
          // this.formData.pcy_pdf_path_id = id
          // this.formData.pcy_pdf_path = path
          // this.formData.ins_start_dt = ins_start_dt
          // this.formData.ins_end_dt = ins_end_dt
          // if(pcy_no) {
          //   this.formData.pcy_no = pcy_no
          // }
        }
      }
    },
    detail:{
      immediate:true,
      deep:true,
      handler(val){
        let {ins_end_dt,ins_start_dt} = val
        this.formData.ins_end_dt = ins_end_dt
        this.formData.ins_start_dt = ins_start_dt
      }
    }
  },
  methods: {
    initExtra(){
      let {extra_content_list={},extra_benefits_content} = this.detail
      let extraArr =[]
      if(!extra_content_list )
        extra_content_list = {...extra_benefits_content}
      Object.entries(extra_content_list).filter(item=>{
        let params ={}
        let {file={},name='',pcy_no=''} = item[1]
        let {id} =file||{}
        params[`${item[0]}_path`] = file
        params[`${item[0]}_path_id`] = id
        params.key = item[0]
        params.name = name
        params[`${item[0]}_pcy_no`] = pcy_no
        extraArr.push(params)
      })
      this.extraBenefit = extraArr
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    onNext() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.$refs['send-email-sms'].changeDialog()
        }
      })
    },
    handlerUploadSuccess({ data, result,otherData }) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      const {id = '', name = '', url = '', client_name = ''} = data
      if (target == 'extra_benefits') {
        this.$set(this.extraBenefit[index], nameKey, data)
        this.$set(this.extraBenefit[index], idKey, id)
      }else {
        this.$set(this.formData, 'pcy_pdf', data)
        this.$set(this.formData, 'pcy_pdf_path', name)
        this.$set(this.formData, 'pcy_pdf_path_id', id)
        this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
      }
    },
    handlerDeleteFile({otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      if (target == 'extra_benefits') {
        this.$set(this.extraBenefit[index], nameKey, {})
        this.$set(this.extraBenefit[index], idKey, '')
      }
      else {
        this.$set(this.formData, 'pcy_pdf', null)
        this.$set(this.formData, 'pcy_pdf_path', '')
        this.$set(this.formData, 'pcy_pdf_path_id', '')
        this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
      }
    },
    handlerSend(content,type,data) {
      let {referrer_send,customer_send,referrer_content} = data

      this.network().changeEndorsementStatus({
        content,
        referrer_content,
        is_send_referrer:referrer_send,
        is_send: this.isFina?customer_send:1
      })
    },
    handlerSkip() {
      this.network().changeEndorsementStatus({
        content: '',
        referrer_content: '',
        is_send: 0,
        is_send_referrer:'',
      })
    },
    network() {
      return {
        changeEndorsementStatus: async (params = {}) => {
          let extra_params = {}
          let extra_arr = JSON.parse(JSON.stringify(this.extraBenefit))
          extra_arr.filter(item=>{
            delete item.key
            delete item.name
            extra_params = {...extra_params,...item}
          })
          let extra = {
            id: this.id,
            stts: 601,
            ...params,
            ...this.formData,
            ...extra_params
          }

          const { data } = await changeEndorsementStatus(extra)

          // this.$refs['send-email-sms'].changeDialog()
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  h3 {
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
  .item-content{
    padding-bottom: 30px;
    padding-top: 20px;
    border-bottom: 1px solid #D1D5DA;
    &:last-child{
      border-bottom: 0;
    }
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
}
</style>
